import React, {useEffect} from 'react';

import Navbar from '../Navbar';
import Footer from '../footer';

import BackToTop from '../BackToTop';
import SafetyTip from './SafetyTip';
import Hero from './Hero';


const Index = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}, []);
  return (
    <section>
      <Navbar />

      <Hero />

      <SafetyTip />

      <Footer />

      <BackToTop />
    </section>
  );
};

export default Index;

